import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPrivacySecurity = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {...props}>
    <g
      id="PrivacySecurity_svg__SVGRepo_tracerCarrier"
      stroke="#CCC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.824}
    >
      <defs>
        <style>
          {
            '.PrivacySecurity_svg__a,.PrivacySecurity_svg__b,.PrivacySecurity_svg__c,.PrivacySecurity_svg__d{fill:none;stroke:#4b7eff;stroke-linecap:round;stroke-linejoin:round}.PrivacySecurity_svg__d{stroke-width:2.16}'
          }
        </style>
      </defs>
      <path
        d="M17.753 18.688a4.634 4.634 0 0 1 9.269 0M27.022 18.688v2.789M17.753 18.688v2.752"
        className="PrivacySecurity_svg__a"
      />
      <circle
        cx={22.387}
        cy={27.343}
        r={1.613}
        className="PrivacySecurity_svg__b"
      />
      <path d="M22.387 30.534v-1.528" className="PrivacySecurity_svg__b" />
      <rect
        width={12.848}
        height={12.848}
        x={15.963}
        y={21.098}
        className="PrivacySecurity_svg__c"
        rx={3.545}
      />
      <path
        d="M42.447 34.748A21.499 21.499 0 1 1 23.828 2.5"
        className="PrivacySecurity_svg__d"
      />
    </g>
    <g id="PrivacySecurity_svg__SVGRepo_iconCarrier">
      <path
        d="M17.753 18.688a4.634 4.634 0 0 1 9.269 0M27.022 18.688v2.789M17.753 18.688v2.752"
        className="PrivacySecurity_svg__a"
      />
      <circle
        cx={22.387}
        cy={27.343}
        r={1.613}
        className="PrivacySecurity_svg__b"
      />
      <path d="M22.387 30.534v-1.528" className="PrivacySecurity_svg__b" />
      <rect
        width={12.848}
        height={12.848}
        x={15.963}
        y={21.098}
        className="PrivacySecurity_svg__c"
        rx={3.545}
      />
      <path
        d="M42.447 34.748A21.499 21.499 0 1 1 23.828 2.5"
        className="PrivacySecurity_svg__d"
      />
    </g>
  </svg>
);
export default SvgPrivacySecurity;
